import Vue from 'vue'
import { Config } from '@/services/ConfigService'

Vue.prototype.$envVar = Config

Vue.config.productionTip = true
Vue.config.keyCodes = {
	f2: 113
}
